import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNetworkStatus } from '@shared/hooks/useNetworkStatus';
import { useSnackbar } from '@shared/hooks/useSnackbar';
import { isCapacitorNative } from '@utils/capacitor-utils';

const IS_NATIVE_MOBILE = isCapacitorNative();

export const NetworkStatusNotifier = () => {
  const { t } = useTranslation();
  const { isOnline, wasOffline, setWasOffline } = useNetworkStatus();
  const { showSnackbar } = useSnackbar();

  useEffect(() => {
    if (!isOnline) {
      showSnackbar({
        message: t('networkStatus.offline'),
        messageTitle: t('networkStatus.offlineTitle'),
        severity: 'warning',
        duration: 6000,
        floatingPosition: IS_NATIVE_MOBILE ? 'center' : 'leading'
      });
    } else if (wasOffline) {
      showSnackbar({
        message: t('networkStatus.backOnline'),
        messageTitle: t('networkStatus.backOnlineTitle'),
        severity: 'success'
      });
      setWasOffline(false);
    }
  }, [isOnline, wasOffline, showSnackbar, t, setWasOffline]);

  return null;
};
